"use strict";

exports.__esModule = true;
exports.TextValue = void 0;
exports.fitFontSizeToHeight = fitFontSizeToHeight;
var _useUiDesign2 = require("../../Theme/UiDesign/useUiDesign");
var _react = _interopRequireDefault(require("react"));
var _polished = require("polished");
var _approximateFontSize = require("../approximateFontSize");
var _calculateXY2 = require("../calculateXY");
var _constants = require("../../constants");
var _excluded = ["width", "height", "value", "color", "backgroundColor", "fontSize", "fontWeight", "fontFamily", "textAnchor", "subText", "centerVertically", "dataTestId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Cap font so optically-centered glyphs stay inside the box.
 * Only used when centerVertically is requested.
 */
function fitFontSizeToHeight(fontSize, height) {
  if (!height || height <= 0) {
    return fontSize;
  }
  return Math.max(8, Math.min(fontSize, Math.floor(height * 0.55)));
}

/**
 * Displays a single-line text value in an SVG.
 * Fills the available space.
 */
var TextValue = exports.TextValue = function TextValue(props) {
  var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
    modern = _useUiDesign.modern;
  var width = props.width,
    height = props.height,
    value = props.value,
    color = props.color,
    backgroundColor = props.backgroundColor,
    fontSize = props.fontSize,
    fontWeight = props.fontWeight,
    fontFamily = props.fontFamily,
    _props$textAnchor = props.textAnchor,
    textAnchor = _props$textAnchor === void 0 ? _constants.TEXT_ANCHOR_MIDDLE : _props$textAnchor,
    subText = props.subText,
    _props$centerVertical = props.centerVertically,
    centerVertically = _props$centerVertical === void 0 ? false : _props$centerVertical,
    _props$dataTestId = props.dataTestId,
    dataTestId = _props$dataTestId === void 0 ? "TextValue" : _props$dataTestId,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var _calculateXY = (0, _calculateXY2.calculateXY)({
      width: width,
      height: height,
      textAnchor: textAnchor
    }),
    x = _calculateXY.x,
    y = _calculateXY.y;
  var subTextY = height * 3 / 4;

  // Modern: a configured font size is a maximum, and text that would not fit
  // the box shrinks to the size that does. Legacy: the configured size wins.
  var autoSize = subText ? (0, _approximateFontSize.approximateFontSize)({
    width: width,
    height: subTextY,
    value: value
  }) : (0, _approximateFontSize.approximateFontSize)({
    width: width,
    height: height,
    value: value
  });
  var rawSize = modern ? (0, _approximateFontSize.fitFontSize)(fontSize, autoSize) : fontSize || autoSize;
  var textSize = !subText && centerVertically ? fitFontSizeToHeight(rawSize, height) : rawSize;
  var finalY = subText ? subTextY : centerVertically ? height / 2 + textSize * 0.35 : y;
  var textColor = !color && backgroundColor && backgroundColor !== "transparent" ? (0, _polished.readableColor)(backgroundColor) : color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: width,
    height: height
  }, extra, {
    style: {
      overflow: "hidden"
    },
    "data-testid": dataTestId
  }), backgroundColor && /*#__PURE__*/_react["default"].createElement("rect", {
    style: {
      transition: "fill .4s ease"
    },
    fill: backgroundColor,
    x: 0,
    y: 0,
    width: width,
    height: height
  }), /*#__PURE__*/_react["default"].createElement("text", {
    x: x,
    y: finalY,
    textAnchor: textAnchor,
    fill: textColor || "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("tspan", {
    fontSize: textSize,
    fontWeight: fontWeight,
    fontFamily: fontFamily,
    alignmentBaseline: "middle",
    "data-testid": "TextValueSpan"
  }, value)));
};